import {ServiceProviderHub} from "@generated-backend-types";
import MultilingualAttributeData = ServiceProviderHub.App.Data.Meta.MultilingualAttributeData;
import { ListItem } from "../types/list-item.type";
import {LocaleService} from '../services/locale-service/locale.service';


export function sortListByGivenKey<Model extends BaseResource>(
  list: (ListItem & { model: Model })[],
  sortByKey: keyof Model | undefined,
  localeService: LocaleService
): (ListItem & { model: Model })[] {

  function isMultilingualAttributeData(value: Model[keyof Model] | MultilingualAttributeData): value is MultilingualAttributeData {
    return typeof value === 'object' && value !== null &&  ('en' in Object.keys(value) && 'de' in Object.keys(value) && Object.keys(value).length === 2);
  }

  function compareValues(a: Model[keyof Model] | string | number | boolean, b: Model[keyof Model] |string | number | boolean): number {
    if (typeof a === 'string' && typeof b === 'string') {
      return a.localeCompare(b);
    }
    if (typeof a === 'number' && typeof b === 'number') {
      return a - b;
    }
    if (typeof a === 'boolean' && typeof b === 'boolean') {
      return Number(a) - Number(b);
    }
    return 0;
  }


  if (sortByKey) {
    return [...list].sort((a, b) => {
      const aValue: Model[keyof Model] = a.model[sortByKey];
      let finalAValue: Model[keyof Model] | string | number | boolean;

      if (isMultilingualAttributeData(aValue)) {
        finalAValue = aValue[localeService.currentLocale];
      } else {
        finalAValue = aValue;
      }

      const bValue = b.model[sortByKey];
      let finalBValue: Model[keyof Model] | string | number | boolean;

      if (isMultilingualAttributeData(bValue)) {
        finalBValue = bValue[localeService.currentLocale];
      } else {
        finalBValue = bValue;
      }

      return compareValues(finalAValue, finalBValue);
    });
  }
  return list;
}
